import React from "react";
import styled from "styled-components";
import { colors, radius } from "../theme";
import { AppScroll, AppEyebrow, AppTitle, Chip, ChipRow } from "./shared";

const coursework = [
  "Data Structures",
  "Linear Algebra",
  "Discrete Mathematics",
  "Fundamentals of Computer Systems",
  "Advanced Programming",
  "Computer Science Theory",
  "Artificial Intelligence",
  "Natural Language Processing",
  "Computer Networks",
  "Computational Aspects of Robotics",
  "Computer Vision",
];

const Card = styled.div`
  border: 2px solid ${colors.ink};
  border-left: 8px solid ${colors.lilac};
  border-radius: ${radius.md};
  background: #fff;
  padding: 20px 22px;
  box-shadow: 4px 4px 0 rgba(29, 29, 31, 0.12);
  margin-top: 16px;
`;

const School = styled.h3`
  margin: 0;
  font-size: 21px;
  font-weight: 700;
`;

const Degree = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${colors.inkSoft};
  margin: 4px 0 2px;
`;

const Meta = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.inkFaint};
  margin-bottom: 16px;
`;

const CourseLabel = styled.div`
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: 700;
  color: ${colors.inkFaint};
  margin-bottom: 10px;
`;

const EducationApp = () => (
  <AppScroll>
    <AppEyebrow>Where it started</AppEyebrow>
    <AppTitle>Education</AppTitle>
    <Card>
      <School>Columbia University</School>
      <Degree>B.A. Computer Science, Intelligent Systems Track</Degree>
      <Meta>New York, NY &middot; Aug 2017 - May 2021</Meta>
      <CourseLabel>Relevant Coursework</CourseLabel>
      <ChipRow>
        {coursework.map((course) => (
          <Chip key={course} $bg={colors.butter}>
            {course}
          </Chip>
        ))}
      </ChipRow>
    </Card>
  </AppScroll>
);

export default EducationApp;
